import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";


export const SimuladorIncentivosRRiego = ({ rango = null }) => {

    const [state, setState] = useState({
        meta_total: 0,
        venta_productos: 0,
        venta_proyectos: 0,
        real_total: 0,
        cumplimiento: 0,
        porcentaje_productos: 0,
        porcentaje_proyectos: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };

    useEffect(() => {
        const real_total = Number(state.venta_productos) + Number(state.venta_proyectos);
        
        if (Number(state.meta_total) !== 0 && Number(real_total) !== 0) {
            
            const cumplimiento = truncar((Number(real_total) / Number(state.meta_total)) * 100);
            var porcentaje_productos = 0;
            var porcentaje_proyectos = 0;
            var incentivo_productos = 0;
            var incentivo_proyectos = 0;
            var incentivo = 0;
            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= cumplimiento && index.maximo >= cumplimiento) {
                        porcentaje_productos = index.porcentaje_productos;
                        porcentaje_proyectos = index.porcentaje_proyectos;
                        incentivo_productos =
                            Number(state.venta_productos) * porcentaje_productos;
                        incentivo_proyectos =
                            Number(state.venta_proyectos) * porcentaje_proyectos;
                        incentivo = Number(incentivo_productos) + Number(incentivo_proyectos)
                    }
                });
            }

            setState((prev) => ({
                ...prev,
                real_total,
                cumplimiento,
                porcentaje_productos: porcentaje_productos * 100,
                porcentaje_proyectos: porcentaje_proyectos * 100,
                incentivo,
            }));
        }
    }, [state.meta_total, state.real_total, state.venta_productos, state.venta_proyectos]);

    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Objetivo de venta</div>
                    <SimuladorNumericInput
                        name="meta_total"
                        label=""
                        value={state.meta_total}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Venta total de productos</div>
                    <SimuladorNumericInput
                        name="venta_productos"
                        label=""
                        value={state.venta_productos}
                        disabled={false}
                        onChange={handleChange}
                        icono="pesos"
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Venta total proy. de riego</div>
                    <SimuladorNumericInput
                        name="venta_proyectos"
                        label=""
                        value={state.venta_proyectos}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>


            </div>

            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Cumplimiento de venta</div>
                    <SimuladorNumericInput
                        name="cumplimiento"
                        label=""
                        value={state.cumplimiento}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>

            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">% Incentivo a ganar productos</div>
                    <SimuladorNumericInput
                        name="proyectos"
                        label=""
                        value={state.porcentaje_productos}
                        disabled={true}
                        onChange={handleChange}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>

                <div className="input-section">
                    <div className="input-title-label">% incentivo a ganar proy. de riego</div>
                    <SimuladorNumericInput
                        name="porcentaje_proyecto"
                        label=""
                        value={state.porcentaje_proyectos}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>


            </div>

            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        icono="pesos"
                        inputTotal="si"
                    />
                </div>
            </div>
        </div >
    );
};
